module.exports = __webpack_public_path__ + "static/scratch-1-1-5b77a70516d69839dc1d22959e259565.png";